import { render, staticRenderFns } from "./pagination.vue?vue&type=template&id=abe34632&scoped=true"
import script from "./pagination.ts?vue&type=script&lang=ts&external"
export * from "./pagination.ts?vue&type=script&lang=ts&external"
import style0 from "./pagination.scss?vue&type=style&index=0&id=abe34632&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abe34632",
  null
  
)

export default component.exports